import { render, staticRenderFns } from "./MagniusPayment.vue?vue&type=template&id=1a6159d5"
import script from "./MagniusPayment.vue?vue&type=script&lang=js"
export * from "./MagniusPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports